import angular from "angular";

angular
    .module('app')
    .component('organizationInfo', {
        template: require('./organization-info.html'),
        controller: [controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&',
        }
    });

function controller() {

    const $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.organization = $ctrl.resolve.organization;

        $ctrl.emails = $ctrl.organization.contacts.filter(v => v.type === 'email').map(v => v.value).join(', ');

        $ctrl.phones = $ctrl.organization.contacts.filter(v => v.type === 'phone').map(v => v.value).join(', ');
    };
}



// WEBPACK FOOTER //
// ./resources/assets/modules/components/organization-info/organization-info.js